module.exports = __webpack_public_path__ + "img/collapse.e7e9054d.svg";